/* ============================================================================
 * formulapro.js — Baby Brezza Poland Formula Settings
 * Migrated to v2 API: https://api.babybrezzacloud.com/formulas/finder/*
 * Endpoints:
 *   GET /territories
 *   GET /brands?territory=
 *   GET /types?territory=&brand=
 *   GET /stages?territory=&brand=&type=
 *   GET /settings?territory=&brand=&type=&stage=&alt_mfg_setting=false
 *   GET /settings/upc?upc=&alt_mfg_setting=false
 * Notes:
 *   - UI text in Polish (babybrezza.pl).
 *   - alt_mfg_setting is always sent as 'false'.
 *   - Public function names (proc, GetTerritoryData, getbrand, gettypepro,
 *     getstagesettign, findByUpc, getData, validateFormSubmission, etc.) kept
 *     because the section template wires them to inline onChange handlers.
 * ============================================================================ */

// ===== Switch between 'prod' and 'dev' for the formula API + image hosts =====
var FORMULA_ENV = 'prod';
// =============================================================================

var CONFIG = {
  API_URL: FORMULA_ENV === 'prod'
    ? 'https://api.babybrezzacloud.com/formulas/finder'
    : 'https://dev-api.babybrezzacloud.com/formulas/finder',
  IMAGE_BASE: FORMULA_ENV === 'prod'
    ? 'https://babybrezzacloud.com/uploads/formulaprotool/original'
    : 'https://dev.babybrezzacloud.com/uploads/formulaprotool/original',
  ALT_MFG_SETTING: 'false',
  klaviyoApiUrl: 'https://optin.babybrezza.com/api/subscribe/klaviyo',
  BABYB_STORE: 'babybrezza.pl',
  LANGUAGE: 'pl'
};

// ===== Module-scoped state ===================================================
var detecthttp = window.location.protocol;
var StoreURL = CONFIG.API_URL; // kept as a global for back-compat
var isEU = false;
var isProAdvanced = false;
var selected_model_type = '';
var selected_country_code = '';
var selected_formula_brand = '';
var salesforce_url = 'https://knowledge.babybrezza.com/s/formula-settings?';
var hasCamera = false;
var detected_upcs = [];
var glob_val;

var abortControllers = { territories: null, brands: null, types: null, settings: null };

var originalPlaceholders = {
  sel_territory: '-- Wybierz kraj/terytorium pochodzenia swojej formuły --',
  sel_brand: '-- Wybierz swoją markę formuły --',
  sel_type: '-- Wybierz etap/przedział wiekowy formuły --'
};

if (typeof Quagga !== 'undefined') {
  Quagga.onDetected(function (result) {
    if (detected_upcs.includes(result.codeResult.code)) {
      detected_upcs = [];
      $("#upc_input").val(result.codeResult.code);
      $("#upc_enter").get(0).click();
      Quagga.stop();
      $("#interactive").hide();
    } else {
      detected_upcs.push(result.codeResult.code);
    }
  });
}

// ===== Utilities =============================================================
const scrollToID = (id) => {
  $("html, body").animate({ scrollTop: $(id).offset().top - 85 }, 250, "swing");
};

function getUserCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1);
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
  }
  return "";
}

function safeDecode(v) {
  if (!v) return '';
  try { return decodeURIComponent(v); } catch (_) { return v; }
}

function escapeHTML(str) {
  if (str === undefined || str === null) return '';
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function fetchJSON(url, controllerKey) {
  if (controllerKey && abortControllers[controllerKey]) {
    abortControllers[controllerKey].abort();
  }
  var opts = { cache: 'no-store' };
  if (controllerKey) {
    var ctrl = new AbortController();
    abortControllers[controllerKey] = ctrl;
    opts.signal = ctrl.signal;
  }
  return fetch(url, opts).then(function (r) {
    if (!r.ok) throw new Error('HTTP ' + r.status);
    return r.json();
  });
}

function preservePlaceholder(selectEl, fallback) {
  var first = selectEl && selectEl.options && selectEl.options[0];
  if (first && first.text && !first.value) return first.text;
  return fallback || '-- Wybierz --';
}

function rebuildSelect(selectEl, items, placeholder) {
  if (!selectEl) return;
  var html = '<option value="">' + escapeHTML(placeholder) + '</option>';
  (items || []).forEach(function (item) {
    var v = escapeHTML(item);
    html += '<option value="' + v + '">' + v + '</option>';
  });
  selectEl.innerHTML = html;
  selectEl.selectedIndex = 0;
  enhanceSelectSearch(selectEl);
}

function setSelectLoading(selector, isLoading) {
  var el = document.querySelector(selector);
  if (!el) return;
  el.disabled = !!isLoading;
  el.classList.toggle('formula-loading', !!isLoading);
  var wrapper = el.parentNode;
  if (!wrapper) return;
  var searchInput = wrapper.querySelector(':scope > .search-select-input');
  if (searchInput) searchInput.disabled = !!isLoading;
}

// ===== Lightweight toast (used by select-search guards) ======================
var _searchToast = { msg: '', at: 0 };
function showSearchToast(message, duration) {
  duration = duration || 2500;
  var now = Date.now();
  if (_searchToast.msg === message && (now - _searchToast.at) < 800) return;
  _searchToast.msg = message;
  _searchToast.at = now;

  var container = document.getElementById('formula-search-toast-container');
  if (!container) {
    container = document.createElement('div');
    container.id = 'formula-search-toast-container';
    container.style.cssText = 'position:fixed;bottom:32px;left:50%;transform:translateX(-50%);z-index:2147483646;display:flex;flex-direction:column-reverse;gap:10px;pointer-events:none;max-width:92vw;';
    document.body.appendChild(container);
  }
  var toast = document.createElement('div');
  toast.style.cssText = 'display:flex;align-items:center;gap:12px;background:#fff3cd;color:#5b3a00;padding:14px 22px 14px 18px;border-left:5px solid #f0a500;border-radius:10px;box-shadow:0 10px 28px rgba(0,0,0,0.22),0 2px 6px rgba(0,0,0,0.08);font-size:15px;font-weight:600;line-height:1.4;max-width:100%;text-align:left;letter-spacing:0.1px;opacity:0;transform:translateY(12px);transition:opacity 220ms ease,transform 220ms ease;pointer-events:auto;';
  var icon = document.createElement('span');
  icon.setAttribute('aria-hidden', 'true');
  icon.style.cssText = 'flex:0 0 auto;display:inline-flex;align-items:center;justify-content:center;width:24px;height:24px;border-radius:50%;background:#f0a500;color:#fff;font-weight:700;font-size:15px;line-height:1;';
  icon.textContent = '!';
  var text = document.createElement('span');
  text.style.cssText = 'flex:1 1 auto;';
  text.textContent = message;
  toast.appendChild(icon);
  toast.appendChild(text);
  container.appendChild(toast);
  requestAnimationFrame(function () {
    toast.style.opacity = '1';
    toast.style.transform = 'translateY(0)';
  });
  setTimeout(function () {
    toast.style.opacity = '0';
    toast.style.transform = 'translateY(8px)';
    setTimeout(function () { toast.remove(); }, 240);
  }, duration);
}

// ===== Searchable select replacement =========================================
function enhanceSelectSearch(selectEl) {
  if (!selectEl || !selectEl.parentNode) return;

  var parent = selectEl.parentNode;
  var searchInput = parent.querySelector(':scope > .search-select-input');
  var dropdown;

  if (!searchInput) {
    selectEl.style.display = 'none';
    selectEl.setAttribute('tabindex', '-1');
    selectEl.setAttribute('aria-hidden', 'true');

    searchInput = document.createElement('input');
    searchInput.type = 'search';
    searchInput.className = 'search-select-input';
    searchInput.name = 'search-' + Math.random().toString(36).slice(2, 10);
    searchInput.setAttribute('autocomplete', 'off');
    searchInput.setAttribute('autocorrect', 'off');
    searchInput.setAttribute('autocapitalize', 'off');
    searchInput.setAttribute('spellcheck', 'false');
    searchInput.setAttribute('data-form-type', 'other');
    searchInput.setAttribute('data-lpignore', 'true');
    searchInput.setAttribute('data-1p-ignore', '');
    searchInput.setAttribute('role', 'combobox');
    selectEl.insertAdjacentElement('afterend', searchInput);

    dropdown = document.createElement('div');
    dropdown.className = 'search-select-dropdown';
    dropdown.hidden = true;
    dropdown.setAttribute('role', 'listbox');
    document.body.appendChild(dropdown);

    var positionDropdown = function () {
      var rect = searchInput.getBoundingClientRect();
      var vv = window.visualViewport;
      var vvTop = vv ? vv.offsetTop : 0;
      var vvLeft = vv ? vv.offsetLeft : 0;
      var vvHeight = vv ? vv.height : window.innerHeight;
      var spaceBelow = vvHeight - rect.bottom;
      var availableH = Math.max(120, Math.min(280, spaceBelow - 8));
      dropdown.style.maxHeight = availableH + 'px';
      dropdown.style.left = (rect.left + vvLeft) + 'px';
      dropdown.style.width = rect.width + 'px';
      dropdown.style.top = (rect.bottom + vvTop + 2) + 'px';
    };
    searchInput._positionDropdown = positionDropdown;

    window.addEventListener('scroll', function () { if (!dropdown.hidden) positionDropdown(); }, true);
    window.addEventListener('resize', function () { if (!dropdown.hidden) positionDropdown(); });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', function () { if (!dropdown.hidden) positionDropdown(); });
      window.visualViewport.addEventListener('scroll', function () { if (!dropdown.hidden) positionDropdown(); });
    }

    var renderOptions = function (filter) {
      filter = filter || '';
      dropdown.innerHTML = '';
      var f = filter.trim().toLowerCase();
      var items = Array.prototype.filter.call(selectEl.options, function (o) { return !!o.value; });
      var matches = f ? items.filter(function (o) { return o.text.toLowerCase().indexOf(f) !== -1; }) : items;

      if (matches.length === 0) {
        var empty = document.createElement('div');
        empty.className = 'search-select-empty';
        empty.textContent = 'Brak wyników';
        dropdown.appendChild(empty);
        return;
      }

      matches.forEach(function (opt) {
        var item = document.createElement('div');
        item.className = 'search-select-option';
        item.textContent = opt.text;
        item.dataset.value = opt.value;
        item.setAttribute('role', 'option');
        if (opt.value === selectEl.value) item.classList.add('is-active');
        item.addEventListener('mousedown', function (e) {
          e.preventDefault();
          selectEl.value = opt.value;
          searchInput.value = opt.text;
          dropdown.hidden = true;
          selectEl.dispatchEvent(new Event('change', { bubbles: true }));
        });
        dropdown.appendChild(item);
      });
    };

    var guardSearchInput = function () {
      if (selectEl.id === 'sel_territory') {
        var consentEl = document.getElementById('email_consent_checkbox');
        if (consentEl && !consentEl.checked) {
          showSearchToast('Proszę zaznaczyć zgodę na udostępnienie adresu e-mail.');
          return false;
        }
      }
      if (selectEl.id === 'sel_brand') {
        var territoryId = document.getElementById('sel_territory_id');
        if (!territoryId || !territoryId.value) {
          showSearchToast('Proszę najpierw wybrać kraj.');
          return false;
        }
      }
      if (selectEl.id === 'sel_type') {
        var brandId = document.getElementById('sel_brand_id');
        if (!brandId || !brandId.value) {
          showSearchToast('Proszę najpierw wybrać markę formuły.');
          return false;
        }
      }
      return true;
    };

    searchInput.addEventListener('pointerdown', function (e) {
      if (!guardSearchInput()) {
        e.preventDefault();
        searchInput.blur();
      }
    });
    searchInput.addEventListener('focus', function () {
      if (!guardSearchInput()) { searchInput.blur(); return; }
      renderOptions('');
      searchInput.select();
      positionDropdown();
      dropdown.hidden = false;
    });
    searchInput.addEventListener('click', function () {
      if (!guardSearchInput()) { searchInput.blur(); return; }
      if (dropdown.hidden) {
        renderOptions('');
        searchInput.select();
        positionDropdown();
        dropdown.hidden = false;
      }
    });
    searchInput.addEventListener('input', function () {
      if (!guardSearchInput()) {
        searchInput.value = '';
        searchInput.blur();
        dropdown.hidden = true;
        return;
      }
      renderOptions(searchInput.value);
      positionDropdown();
      dropdown.hidden = false;
    });
    searchInput.addEventListener('blur', function () {
      setTimeout(function () {
        dropdown.hidden = true;
        var selOpt = selectEl.options[selectEl.selectedIndex];
        searchInput.value = (selOpt && selOpt.value) ? selOpt.text : '';
      }, 150);
    });
    searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        dropdown.hidden = true;
        searchInput.blur();
      }
    });

    searchInput._renderOptions = renderOptions;
  }

  var firstOpt = selectEl.options[0];
  var selOpt = selectEl.options[selectEl.selectedIndex];
  searchInput.placeholder = firstOpt ? firstOpt.text : 'Wybierz...';
  searchInput.value = (selOpt && selOpt.value) ? selOpt.text : '';
  if (searchInput._renderOptions) searchInput._renderOptions('');
}

// ===== Marketing opt-in (Klaviyo) ============================================
async function addInformationToKlaviyo(model_type = "", request_type = "") {
  let optIn;
  const emailEl = document.getElementById('enter_email_input');
  const email = emailEl ? (emailEl.value || '').trim() : '';

  if (request_type === "warranty") {
    const isSubscribedEl = document.getElementById('isSubscribed');
    optIn = isSubscribedEl ? isSubscribedEl.checked : false;
    if (!optIn) return;
  } else {
    const consentEl = document.getElementById('consent_checkbox_1');
    optIn = consentEl ? consentEl.checked : false;
    if (!optIn) return;
  }

  let selected_model_type_label = "Formula Pro Advanced";
  if (model_type === "advanced") {
    selected_model_type_label = "Formula Pro Advanced";
  } else if (model_type === "advanced_wifi") {
    selected_model_type_label = "Formula Pro Advanced WiFi";
  } else if (model_type === "pro_mini") {
    selected_model_type_label = "Formula Pro Mini";
  }

  if (!email || !selected_model_type_label) {
    console.warn('[Klaviyo] Skipped — missing email or product');
    return;
  }

  const payload = {
    email: email,
    store: "PL",
    selectedProduct: selected_model_type_label
  };

  try {
    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "revision": "2023-10-15"
      },
      body: JSON.stringify(payload)
    };
    const response = await fetch(CONFIG.klaviyoApiUrl, params);
    if (!response.ok) {
      const error = await response.text();
      console.log(error);
      return;
    }
  } catch (err) {
    console.log(err);
  }
}

// ===== Legacy settings log (analytics) =======================================
function sendLegacySettingsLog(opts) {
  try {
    opts = opts || {};
    var territory = opts.territory || safeDecode($("#sel_territory_id").val() || '');
    var brand = opts.brand || safeDecode($("#sel_brand_id").val() || '');
    var type = opts.type || safeDecode($("#sel_type_id").val() || '');
    var modelType = $("#model_type").val() || '';
    var email = $("#enter_email_input").val() || '';

    var formData = new URLSearchParams();
    formData.append('type_id', type);
    formData.append('brand_id', brand ? encodeURIComponent(brand) : '');
    formData.append('territory_id', territory);
    formData.append('model_type', modelType);
    formData.append('email', email);
    formData.append('language', CONFIG.LANGUAGE);
    formData.append('ip_address', getUserCookie('ip_address') || '');
    formData.append('user_agent', navigator.userAgent);
    formData.append('touch_device', String('ontouchstart' in window || navigator.maxTouchPoints > 0));
    formData.append('state_prov', getUserCookie('state_prov') || '');
    formData.append('zip', getUserCookie('zip') || '');
    formData.append('country', getUserCookie('country') || '');
    formData.append('city', getUserCookie('city') || '');
    formData.append('babyb_store', CONFIG.BABYB_STORE);

    if (opts.upc) formData.append('upc', opts.upc);
    if (opts.lot_number) formData.append('lot_number', opts.lot_number);
    if (opts.stage !== undefined && opts.stage !== null && opts.stage !== '') {
      formData.append('stage', String(opts.stage));
    }

    fetch('https://babybrezzaserver.com/index.php/without_response/getsetting', {
      method: 'POST',
      body: formData,
      keepalive: true
    }).catch(function () {});
  } catch (e) { /* never break the main flow */ }
}

// ===== Form validation =======================================================
function checkEmailSubmit() {
  var emailInput = document.getElementById("enter_email_input");
  if (!emailInput) return true;
  var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (emailRegex.test(emailInput.value)) {
    $("#invalid_email").hide();
    $("#enter_email_input").removeClass("invalid");
    return true;
  }
  $("#invalid_email").show();
  $("#enter_email_input").addClass("invalid");
  return false;
}

function checkConsentCheckboxes() {
  var checkbox1 = document.getElementById("consent_checkbox_1");
  var checkbox2 = document.getElementById("consent_checkbox_2");
  if (!checkbox1 || !checkbox2) return true; // not present on this page — skip
  if (checkbox1.checked && checkbox2.checked) {
    $("#invalid_consent").hide();
    $("#consent_checkbox_1, #consent_checkbox_2").removeClass("invalid");
    return true;
  }
  $("#invalid_consent").show();
  $("#consent_checkbox_1, #consent_checkbox_2").addClass("invalid");
  return false;
}

function checkEmailConsent() {
  var consentEl = document.getElementById("email_consent_checkbox");
  if (!consentEl) return true; // not present on this page — skip
  if (consentEl.checked) return true;
  if (typeof showSearchToast === 'function') {
    showSearchToast('Proszę zaznaczyć zgodę na udostępnienie adresu e-mail.');
  }
  try { consentEl.focus({ preventScroll: false }); } catch (e) { consentEl.focus(); }
  return false;
}

function validateFormSubmission() {
  return checkEmailSubmit() && checkConsentCheckboxes() && checkEmailConsent();
}

// ===== Result rendering ======================================================
function buildSettingsTableHTML(rows) {
  if (!rows || !rows.length) {
    return '<div class="wrapper"><p>Nie znaleziono ustawień dla tej formuły.</p></div>';
  }
  var bodyHTML = rows.map(function (r) {
    var settingVal = (r.setting === undefined || r.setting === null || r.setting === '') ? '-' : r.setting;
    var stageVal = (r.stage === undefined || r.stage === null || r.stage === '') ? '-' : r.stage;
    return '<tr><td>' + escapeHTML(stageVal) + '</td><td>' + escapeHTML(settingVal) + '</td></tr>';
  }).join('');

  return (
    '<div class="wrapper formula-settings-result">' +
      '<table class="formula-settings-table">' +
        '<thead><tr><th>ETAP</th><th>USTAWIENIE</th></tr></thead>' +
        '<tbody>' + bodyHTML + '</tbody>' +
      '</table>' +
      '<div class="formula-settings-note">' +
        '<p><strong>Uwagi do ustawień</strong></p>' +
        '<p>Skorzystaj z poniższych zdjęć, aby potwierdzić, że wybrałeś właściwą formułę</p>' +
      '</div>' +
    '</div>'
  );
}

function buildImagesHTML(images) {
  if (!images || !images.length) return '';
  var imgsHTML = images.map(function (image) {
    var src = CONFIG.IMAGE_BASE + '/' + escapeHTML(image);
    return (
      '<div class="formula-image-wrapper">' +
        '<img class="formula-image" data-image-preview loading="lazy" ' +
             'alt="' + escapeHTML(image) + '" src="' + src + '" />' +
      '</div>'
    );
  }).join('');
  return '<div class="formula-images-container">' + imgsHTML + '</div>';
}

// ===== Image preview modal (lightbox) ========================================
function ensureImagePreviewModal() {
  if (document.getElementById('formula-image-preview-modal')) return;

  var modal = document.createElement('div');
  modal.id = 'formula-image-preview-modal';
  modal.className = 'formula-image-preview-modal';
  modal.setAttribute('role', 'dialog');
  modal.setAttribute('aria-modal', 'true');
  modal.setAttribute('aria-hidden', 'true');
  modal.hidden = true;
  modal.innerHTML =
    '<div class="formula-image-preview-modal__backdrop"></div>' +
    '<div class="formula-image-preview-modal__dialog" role="document">' +
      '<button type="button" class="formula-image-preview-modal__close" aria-label="Zamknij">&times;</button>' +
      '<img class="formula-image-preview-modal__img" alt="" />' +
    '</div>';
  document.body.appendChild(modal);

  var imgEl = modal.querySelector('.formula-image-preview-modal__img');
  var closeBtn = modal.querySelector('.formula-image-preview-modal__close');
  var backdrop = modal.querySelector('.formula-image-preview-modal__backdrop');

  function closeModal() {
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    imgEl.removeAttribute('src');
    document.body.style.overflow = '';
  }

  closeBtn.addEventListener('click', closeModal);
  backdrop.addEventListener('click', closeModal);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.matches || !target.matches('img[data-image-preview]')) return;
    e.preventDefault();
    imgEl.src = target.src;
    imgEl.alt = target.alt || '';
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  });
}

function injectFormulaStyles() {
  if (document.getElementById('formulapro-inline-styles')) return;
  var style = document.createElement('style');
  style.id = 'formulapro-inline-styles';
  style.textContent = [
    '.formula-settings-result{padding:10px 0;}',
    '.formula-settings-table{width:100%;max-width:480px;margin:10px auto;border-collapse:separate;border-spacing:0;border:1px solid #e3e6e8;border-radius:8px;overflow:hidden;background:#fff;box-shadow:0 1px 3px rgba(0,0,0,.06);}',
    '.formula-settings-table th,.formula-settings-table td{padding:14px 18px;text-align:center;font-size:16px;}',
    '.formula-settings-table thead th,.formula-settings-table thead tr,.formula-settings-table thead tr th{background:#20809b !important;color:#fff !important;font-weight:700;letter-spacing:.5px;text-transform:uppercase;font-size:14px;}',
    '.formula-settings-table tbody tr:nth-child(even) td{background:#f7fafb;}',
    '.formula-settings-table tbody td{border-top:1px solid #eef1f3;color:#1a2b33;font-weight:600;}',
    '.formula-settings-note{max-width:480px;margin:14px auto 4px;padding:12px 16px;background:#f4f8fa;border-left:4px solid #20809b;border-radius:6px;color:#1a2b33;font-size:14px;line-height:1.45;}',
    '.formula-settings-note p{margin:0 0 6px;}',
    '.formula-settings-note p:last-child{margin-bottom:0;}',
    '.formula-settings-note strong{color:#20809b;font-size:14px;letter-spacing:.3px;text-transform:uppercase;}',
    '.formula-images-container{display:flex;flex-wrap:wrap;justify-content:center;gap:14px;margin:14px 0;}',
    '.formula-image-wrapper{flex:0 0 auto;}',
    '.formula-image{display:block;max-width:240px;max-height:300px;width:auto;height:auto;cursor:zoom-in;transition:transform .15s ease;}',
    '.formula-image:hover{transform:scale(1.02);}',
    'select.formula-loading{opacity:.6;cursor:wait;}',
    '#upc_settings .upc-result-meta p{color:#000;margin:4px 0;}',
    '.upc-result-cards{display:grid;grid-template-columns:1fr;gap:18px;max-width:560px;margin:10px auto;align-items:stretch;}',
    '.upc-result-cards.is-multi{grid-template-columns:repeat(2,minmax(0,1fr));max-width:900px;}',
    '@media (max-width:640px){.upc-result-cards.is-multi{grid-template-columns:1fr;max-width:560px;}}',
    '.upc-card{display:flex;flex-direction:column;background:#fff;border:1px solid #e3e6e8;border-radius:10px;box-shadow:0 1px 3px rgba(0,0,0,.06);overflow:hidden;height:100%;}',
    '.upc-card-image{display:flex;align-items:center;justify-content:center;background:#f7fafb;padding:14px;height:200px;flex:0 0 200px;}',
    '.upc-card-image img.formula-image{max-width:100%;max-height:100%;width:auto;height:auto;object-fit:contain;}',
    '.upc-card-body{padding:14px 16px 16px;display:flex;flex-direction:column;flex:1 1 auto;gap:10px;}',
    '.upc-card-meta{flex:1 1 auto;}',
    '.upc-card-meta p{margin:2px 0;color:#1a2b33;font-size:14px;line-height:1.4;}',
    '.upc-card-meta p strong{color:#20809b;}',
    '.upc-card-setting{display:flex;align-items:center;justify-content:space-between;margin-top:auto;padding:10px 14px;background:#20809b;color:#fff;border-radius:6px;}',
    '.upc-card-setting-label{font-size:13px;font-weight:700;letter-spacing:.5px;text-transform:uppercase;}',
    '.upc-card-setting-value{font-size:22px;font-weight:700;line-height:1;}',
    '.search-select-input{width:100%;padding:10px 14px;border:1px solid #bcbec0;border-radius:4px;background:#fff;font-size:15px;color:#1a2b33;box-sizing:border-box;transition:border-color .15s ease,box-shadow .15s ease;}',
    '.search-select-input:focus{outline:none;border-color:#20809b;box-shadow:0 0 0 3px rgba(32,128,155,.18);}',
    '.search-select-input:disabled{opacity:.6;cursor:wait;}',
    '.search-select-dropdown{position:fixed;z-index:2147483646;background:#fff;border:1px solid #d6dadd;border-radius:6px;box-shadow:0 12px 28px rgba(0,0,0,.18),0 2px 6px rgba(0,0,0,.06);overflow-y:auto;}',
    '.search-select-dropdown[hidden]{display:none !important;}',
    '.search-select-option{padding:10px 14px;font-size:15px;color:#1a2b33;cursor:pointer;border-bottom:1px solid #f1f3f5;}',
    '.search-select-option:last-child{border-bottom:none;}',
    '.search-select-option:hover{background:#f4f8fa;}',
    '.search-select-option.is-active{background:#e6f1f5;color:#20809b;font-weight:600;}',
    '.search-select-empty{padding:12px 14px;font-size:14px;color:#7c8a93;font-style:italic;}',
    '.formula-image-preview-modal{position:fixed;inset:0;z-index:2147483646;display:flex;align-items:center;justify-content:center;}',
    '.formula-image-preview-modal[hidden]{display:none !important;}',
    '.formula-image-preview-modal__backdrop{position:absolute;inset:0;background:rgba(0,0,0,.78);}',
    '.formula-image-preview-modal__dialog{position:relative;max-width:92vw;max-height:92vh;display:flex;align-items:center;justify-content:center;}',
    '.formula-image-preview-modal__img{display:block;max-width:92vw;max-height:92vh;width:auto;height:auto;border-radius:8px;box-shadow:0 12px 40px rgba(0,0,0,.45);background:#fff;}',
    '.formula-image-preview-modal__close{position:absolute;top:-12px;right:-12px;width:40px;height:40px;border-radius:50%;border:none;background:#fff;color:#1a2b33;font-size:26px;line-height:1;cursor:pointer;box-shadow:0 4px 14px rgba(0,0,0,.3);display:flex;align-items:center;justify-content:center;}',
    '.formula-image-preview-modal__close:hover{background:#f0f4f6;}'
  ].join('\n');
  document.head.appendChild(style);
}

// ===== UPC search ============================================================
function buildUpcResultCardHTML(item) {
  var brand = item.brand || '';
  var type = item.type || '';
  var stage = (item.stage === undefined || item.stage === null) ? '' : String(item.stage);
  var settingVal = (item.setting === undefined || item.setting === null || item.setting === '') ? '-' : item.setting;
  var territory = Array.isArray(item.territory)
    ? item.territory.filter(Boolean).join(', ')
    : (item.territory || '');
  var images = Array.isArray(item.image)
    ? item.image
    : (Array.isArray(item.images) ? item.images : []);

  var imageHTML = '';
  if (images.length) {
    var src = CONFIG.IMAGE_BASE + '/' + escapeHTML(images[0]);
    imageHTML =
      '<div class="upc-card-image">' +
        '<img class="formula-image" data-image-preview loading="lazy" ' +
             'alt="' + escapeHTML((brand + ' ' + type).trim()) + '" src="' + src + '" />' +
      '</div>';
  }

  var metaHTML =
    (brand     ? '<p><strong>Marka:</strong> ' + escapeHTML(brand) + '</p>'   : '') +
    (type      ? '<p><strong>Typ:</strong> ' + escapeHTML(type) + '</p>'      : '') +
    (stage     ? '<p><strong>Etap:</strong> ' + escapeHTML(stage) + '</p>'    : '') +
    (territory ? '<p><strong>Kraj:</strong> ' + escapeHTML(territory) + '</p>' : '');

  return (
    '<div class="upc-card">' +
      imageHTML +
      '<div class="upc-card-body">' +
        (metaHTML ? '<div class="upc-card-meta">' + metaHTML + '</div>' : '') +
        '<div class="upc-card-setting">' +
          '<span class="upc-card-setting-label">Ustawienie</span>' +
          '<span class="upc-card-setting-value">' + escapeHTML(settingVal) + '</span>' +
        '</div>' +
      '</div>' +
    '</div>'
  );
}

function findByUpc(upc) {
  $("#upc_results").show();
  $("#sel_territory").prop("selectedIndex", 0);
  var brandSelEl = document.getElementById("sel_brand");
  var typeSelEl = document.getElementById("sel_type");
  if (brandSelEl) rebuildSelect(brandSelEl, [], originalPlaceholders.sel_brand);
  if (typeSelEl) rebuildSelect(typeSelEl, [], originalPlaceholders.sel_type);
  $("#upc_settings").show();

  var params = new URLSearchParams({ upc: upc, alt_mfg_setting: CONFIG.ALT_MFG_SETTING });
  fetchJSON(CONFIG.API_URL + '/settings/upc?' + params.toString())
    .then(function (data) {
      addInformationToKlaviyo($("#model_type").val() || '');

      // API can return either an array (single or multiple matches) or a
      // single object (legacy). Normalize and keep only entries that have a
      // usable setting or UPC.
      var raw = Array.isArray(data) ? data : (data ? [data] : []);
      var results = raw.filter(function (r) {
        if (!r) return false;
        var hasSetting = r.setting !== undefined && r.setting !== null && r.setting !== '';
        var upcArr = Array.isArray(r.upc) ? r.upc : [];
        return hasSetting || upcArr.length > 0;
      });

      var upcCode = upc;
      if (results.length) {
        var firstUpcArr = Array.isArray(results[0].upc) ? results[0].upc : [];
        if (firstUpcArr.length) upcCode = firstUpcArr[0];
      }

      if (!results.length) {
        $("#upc_settings").html(
          '<h2 style="text-transform: none; margin-top: 20px; margin-bottom: 15px; font-size: 20px;">' +
            '<strong>Brak wyników dla kodu kreskowego:</strong> ' + escapeHTML(upcCode) +
            '<br>Proszę wybrać markę/typ formuły powyżej</h2>'
        );
        $("#find_stage_setting").html('');
        $("#formula_pro_filter .Formula_sign_up_con").hide();
        return;
      }

      var headerHTML =
        '<h2 style="text-transform: none; margin-top: 20px; margin-bottom: 15px; font-size: 20px; text-align: center;">' +
          '<strong>Wyniki dla kodu kreskowego:</strong> ' + escapeHTML(upcCode) +
        '</h2>';

      var cardsHTML = results.map(buildUpcResultCardHTML).join('');
      var wrapperClass = 'upc-result-cards' + (results.length > 1 ? ' is-multi' : '');

      $("#upc_settings").html(headerHTML);
      $("#find_stage_setting").html(
        '<div class="' + wrapperClass + '">' + cardsHTML + '</div>'
      );
      $("#formula_pro_filter .Formula_sign_up_con").show();

      // Analytics: one ping per matched result so each shown formula is logged.
      results.forEach(function (item) {
        var territoryStr = Array.isArray(item.territory)
          ? item.territory.filter(Boolean).join(', ')
          : (item.territory || '');
        sendLegacySettingsLog({
          territory: territoryStr,
          brand: item.brand || '',
          type: item.type || '',
          upc: upcCode,
          stage: (item.stage === undefined || item.stage === null) ? '' : String(item.stage)
        });
      });

      scrollToID("#formula_pro_filter .Formula_sign_up_con");
    })
    .catch(function (err) {
      if (err && err.name === 'AbortError') return;
      console.error('UPC error:', err);
      $("#find_stage_setting").html(
        "<div class='wrapper'><p style='color: red;'>Przepraszamy, nie udało się załadować ustawień. Spróbuj ponownie lub skontaktuj się z obsługą.</p></div>"
      );
    });
}

// ===== DOM ready =============================================================
$(document).ready(function () {
  $.ajaxSetup({ cache: false });
  injectFormulaStyles();
  ensureImagePreviewModal();

  ['sel_territory', 'sel_brand', 'sel_type'].forEach(function (id) {
    var el = document.getElementById(id);
    if (el) enhanceSelectSearch(el);
  });

  GetTerritoryData(StoreURL);

  $("#tool_filter .additional-info-btn").click(function () {
    scrollToID("#additional_info_mobile");
  });

  $("#upc_enter").on("keypress click", function (e) {
    if (!validateFormSubmission()) {
      $("#sel_type").prop("selectedIndex", 0);
      $("#enter_email_input").focus();
      return;
    }
    if (e.which === 13 || e.type === "click") {
      e.preventDefault();
      var upc = String($("#upc_input").val() || '').trim();
      if (upc) {
        upc = upc.replace(/[^a-z0-9]/gi, "");
        findByUpc(upc);
      }
    }
  });

  $("#start_upc, #upc_start").on("keypress click", function (e) {
    if (!validateFormSubmission()) {
      $("#sel_type").prop("selectedIndex", 0);
      $("#enter_email_input").focus();
      return;
    }
    if (e.which !== 13 && e.type !== "click") return;

    e.preventDefault();

    navigator.mediaDevices.enumerateDevices()
      .then(function (devices) {
        hasCamera = devices.some(function (device) { return device.kind === "videoinput"; });
        if (!hasCamera) {
          $("#result").html(
            '<p style="font-size: 16px; font-weight: 700; text-transform: uppercase; margin:0; color: red;">Nie wykryto kamery<p>'
          );
          return;
        }
        $("#result").html("");
        Quagga.init({
          inputStream: {
            name: "Live",
            type: "LiveStream",
            target: document.querySelector("#interactive"),
            constraints: { facingMode: "environment" }
          },
          decoder: { readers: ["upc_reader", "ean_reader"] },
          locator: { patchSize: 5, halfSample: false },
          numOfWorkers: navigator.hardwareConcurrency || 1,
          frequency: 20,
          locate: true
        }, function (err) {
          if (err) {
            console.error(err);
            return;
          }
          Quagga.start();
          $("#interactive").show();

          Quagga.onProcessed(function (result) {
            var drawingCtx = Quagga.canvas.ctx.overlay;
            var drawingCanvas = Quagga.canvas.dom.overlay;
            drawingCtx.clearRect(0, 0,
              parseInt(drawingCanvas.getAttribute("width")),
              parseInt(drawingCanvas.getAttribute("height"))
            );
            if (result && result.box) {
              Quagga.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, { color: "#00F", lineWidth: 2 });
            }
          });
        });
      })
      .catch(function (err) {
        console.error("Error accessing media devices:", err);
      });
  });

  $("#enter_email_input").on('change input', function () {
    setTimeout(checkEmailSubmit, 100);
  });
});

// ===== Product (model) selection =============================================
function proc(model_type) {
  $("#choose_brand_link").hide();
  $("#choose_stage_link").hide();

  if (model_type == "advanced") {
    selected_model_type = "Formula Pro Advanced";
    jQuery("#add_adv").addClass("active");
    jQuery("#add_adv_wifi, #add_pro_mini").removeClass("active");
    isProAdvanced = false;
    $("#contactFormProduct option[value='553111519266']").prop("selected", true);
  } else if (model_type == "advanced_wifi") {
    selected_model_type = "Formula Pro Advanced WiFi";
    jQuery("#add_adv_wifi").addClass("active");
    jQuery("#add_adv, #add_pro_mini").removeClass("active");
    isProAdvanced = true;
    $("#contactFormProduct option[value='4390264078370']").prop("selected", true);
  } else if (model_type == "pro_mini") {
    selected_model_type = "Formula Pro Mini";
    jQuery("#add_pro_mini").addClass("active");
    jQuery("#add_adv, #add_adv_wifi").removeClass("active");
    isProAdvanced = false;
    $("#contactFormProduct option[value='7084746244276']").prop("selected", true);
  }

  $("#productSelectionDiv").hide();
  $("#warranty_regi_div").show();
  jQuery("#model_type").val("advanced");

  GetTerritoryData(CONFIG.API_URL);
  scrollToID("#formula_pro_filter");
}

// ===== Territory / Brand / Type / Settings flow ==============================
function GetTerritoryData(/* StoreURL */) {
  var sel = document.getElementById("sel_territory");
  var brandSel = document.getElementById("sel_brand");
  var typeSel = document.getElementById("sel_type");

  if (brandSel) rebuildSelect(brandSel, [], originalPlaceholders.sel_brand);
  if (typeSel) rebuildSelect(typeSel, [], originalPlaceholders.sel_type);
  $("#find_stage_setting").html("");

  setSelectLoading('#sel_territory', true);
  fetchJSON(CONFIG.API_URL + '/territories', 'territories')
    .then(function (data) {
      var list = Array.isArray(data) ? data : [];
      var placeholder = preservePlaceholder(sel, originalPlaceholders.sel_territory);
      rebuildSelect(sel, list, placeholder);
    })
    .catch(function (err) {
      if (err && err.name === 'AbortError') return;
      console.error('Territories error:', err);
    })
    .then(function () { setSelectLoading('#sel_territory', false); });
}

function getbrand(val) {
  if (!validateFormSubmission()) {
    $("#sel_territory").prop("selectedIndex", 0);
    $("#enter_email_input").focus();
    return;
  }

  selected_country_code = val || '';
  $("#choose_brand_link").css("display", "inline-block");
  $("#choose_stage_link").hide();

  $("#missing_brand").attr(
    "href",
    salesforce_url +
      "product=" + encodeURIComponent(selected_model_type) +
      "&country=" + encodeURIComponent(selected_country_code)
  );

  isEU = (selected_country_code === "European Union");

  $("#sel_territory_id").val(selected_country_code);
  $("#sel_brand_id").val("");
  $("#sel_type_id").val("");

  $("#us_store_brnd_description, #us_store_brnd_description_mobile, #formula_brand_tooltip").hide();
  if (selected_country_code === "United States of America") {
    $("#us_store_brnd_description, #us_store_brnd_description_mobile, #formula_brand_tooltip").show();
  }

  $("#choose_type").show();
  var brandSel = document.getElementById("sel_brand");
  var typeSel = document.getElementById("sel_type");
  if (typeSel) rebuildSelect(typeSel, [], originalPlaceholders.sel_type);
  $("#find_stage_setting").html("");

  if (!selected_country_code) return;

  setSelectLoading('#sel_brand', true);
  var params = new URLSearchParams({ territory: selected_country_code });
  fetchJSON(CONFIG.API_URL + '/brands?' + params.toString(), 'brands')
    .then(function (data) {
      var list = Array.isArray(data) ? data : [];
      var placeholder = preservePlaceholder(brandSel, originalPlaceholders.sel_brand);
      rebuildSelect(brandSel, list, placeholder);
    })
    .catch(function (err) {
      if (err && err.name === 'AbortError') return;
      console.error('Brands error:', err);
    })
    .then(function () { setSelectLoading('#sel_brand', false); });
}

function gettypepro(val) {
  if (!validateFormSubmission()) {
    $("#sel_brand").prop("selectedIndex", 0);
    $("#enter_email_input").focus();
    return;
  }

  selected_formula_brand = val || '';
  $("#choose_stage_link").css("display", "inline-block");
  $("#missing_stage").attr(
    "href",
    salesforce_url +
      "product=" + encodeURIComponent(selected_model_type) +
      "&country=" + encodeURIComponent(selected_country_code) +
      "&formula_name=" + encodeURIComponent(selected_formula_brand)
  );

  $("#sel_brand_id").val(selected_formula_brand);
  $("#sel_type_id").val("");

  var territory = $("#sel_territory_id").val();
  var typeSel = document.getElementById("sel_type");
  $("#choose_type").show();
  $("#find_stage_setting").html("");

  if (!territory || !selected_formula_brand) return;

  setSelectLoading('#sel_type', true);
  var params = new URLSearchParams({ territory: territory, brand: selected_formula_brand });
  fetchJSON(CONFIG.API_URL + '/types?' + params.toString(), 'types')
    .then(function (data) {
      var list = Array.isArray(data) ? data : [];
      var placeholder = preservePlaceholder(typeSel, originalPlaceholders.sel_type);
      rebuildSelect(typeSel, list, placeholder);

      if (list.length > 0) {
        setTimeout(function () { $("#sel_type option:eq(1)").change(); }, 600);
      }
    })
    .catch(function (err) {
      if (err && err.name === 'AbortError') return;
      console.error('Types error:', err);
    })
    .then(function () { setSelectLoading('#sel_type', false); });
}

function getstagesettign(val) {
  if (!validateFormSubmission()) {
    $("#sel_type").prop("selectedIndex", 0);
    $("#enter_email_input").focus();
    return;
  }

  $("#upc_settings").hide();
  $("#upc_input").val("");

  glob_val = val;
  $("#sel_type_id").val(val || '');

  var territory = $("#sel_territory_id").val();
  var brand = $("#sel_brand_id").val();
  if (!territory || !brand || !val) return;

  $("#find_stage_setting").html(
    "<div class='wrapper'><p style='text-align:center;color:#666;'>Ładowanie…</p></div>"
  );

  var stagesParams = new URLSearchParams({ territory: territory, brand: brand, type: val });
  fetchJSON(CONFIG.API_URL + '/stages?' + stagesParams.toString(), 'settings')
    .then(function (stagesData) {
      var stages = Array.isArray(stagesData) ? stagesData : [];

      var calls = stages.map(function (stageItem) {
        var stageValue, stageName;
        if (stageItem && typeof stageItem === 'object') {
          stageValue = stageItem.stage !== undefined ? stageItem.stage : (stageItem.number !== undefined ? stageItem.number : '');
          stageName = stageItem.name !== undefined ? stageItem.name : (stageItem.label !== undefined ? stageItem.label : String(stageValue));
        } else {
          stageValue = String(stageItem);
          stageName = stageValue;
        }

        var p = new URLSearchParams({
          territory: territory,
          brand: brand,
          type: val,
          alt_mfg_setting: CONFIG.ALT_MFG_SETTING
        });
        if (stageValue !== '' && stageValue !== undefined && stageValue !== null) {
          p.set('stage', stageValue);
        }

        sendLegacySettingsLog({
          territory: territory,
          brand: brand,
          type: val,
          stage: (stageValue === undefined || stageValue === null) ? '' : String(stageValue)
        });

        return fetch(CONFIG.API_URL + '/settings?' + p.toString(), { cache: 'no-store' })
          .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
          .then(function (settingsData) {
            return {
              stage: stageName,
              setting: settingsData && settingsData.setting,
              upc: (settingsData && settingsData.upc) || [],
              image: (settingsData && settingsData.image) || []
            };
          });
      });

      return Promise.all(calls);
    })
    .then(function (rows) {
      var seen = new Set();
      var allImages = [];
      rows.forEach(function (r) {
        (r.image || []).forEach(function (img) {
          if (!seen.has(img)) { seen.add(img); allImages.push(img); }
        });
      });

      $("#find_stage_setting").html(buildSettingsTableHTML(rows) + buildImagesHTML(allImages));
      $(".Formula_sign_up_con").show();

      $("#enjoy-msg, #fps-mail-cta, #more-products-wrapper").show();
      try {
        if (window.$ && $('.more-slider').length && typeof $('.more-slider').slick === 'function') {
          $('.more-slider').slick({
            slidesToShow: 5, slidesToScroll: 1, arrows: true, dots: false,
            infinite: false, focusOnSelect: true, draggable: true, swipeToSlide: true,
            responsive: [
              { breakpoint: 768, settings: { slidesToShow: 2 } },
              { breakpoint: 1024, settings: { slidesToShow: 3 } },
              { breakpoint: 1400, settings: { slidesToShow: 4 } }
            ]
          });
          $(window).on("resize orientationchange", function () { $('.more-slider').slick("resize"); });
        }
      } catch (e) { /* slick may already be initialized — safe to ignore */ }

      var country_code = getUserCookie("country");
      if (country_code === "US") $("#shop-cross-wrapper").show();

      addInformationToKlaviyo($("#model_type").val() || '');

      scrollToID("#formula_pro_filter .Formula_sign_up_con");
    })
    .catch(function (err) {
      if (err && err.name === 'AbortError') return;
      console.error('Settings error:', err);
      $("#find_stage_setting").html(
        "<div class='wrapper'><p style='color: red;'>Przepraszamy, nie udało się załadować ustawień. Spróbuj ponownie lub skontaktuj się z obsługą.</p></div>"
      );
    });
}

function getData() {
  if (!glob_val) return;
  getstagesettign(glob_val);
}

window.addEventListener("klaviyoForms", function (e) {
  if (e.detail && e.detail.type === "submit") getData();
});

(function () {
  var skipBtn = document.querySelector(".fpa_skip");
  if (skipBtn) {
    skipBtn.addEventListener("click", function (e) {
      e.preventDefault();
      getData();
    });
  }
})();

// ===== Back-compat shim =======================================================
function crossDomainAjax(url, querystring, successCallback) {
  $.ajax({
    url: url,
    cache: false,
    timeout: 10000,
    type: "POST",
    data: querystring,
    async: true,
    success: function (data) { successCallback(data); },
    error: function (xhr, status, error) {
      console.error("Error fetching data:", error);
      $("#find_stage_setting").html(
        "<div class='wrapper'><p style='color: red;'>Przepraszamy, nie udało się załadować ustawień. Spróbuj ponownie lub skontaktuj się z obsługą.</p></div>"
      );
    }
  });
}
